import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import PersonIcon from "@mui/icons-material/Person";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
	Alert,
	Button,
	FormControl,
	Grid,
	InputLabel,
	Link,
	Snackbar,
	Typography,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { Link as RouterLink } from "react-router-dom";
import { api } from "../services/apiClient";
import { clearAuthSession, persistAuthSession } from "../services/authStorage";

export const Login = ({ username, setUsername, password, setPassword }) => {
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState(false);
	const [login, setLogin] = useState(false);

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			handleLogin();
		}
	};

	const handleClose = () => {
		setError(false);
		setLogin(false);
	};

	const handleLogin = async () => {
		try {
			const response = await api.post("login.php", {
				mail: username,
				password,
			});

			if (!response.data.success) {
				setError(true);
				return;
			}

			clearAuthSession();
			persistAuthSession({
				accessToken: response.data.accessToken,
				refreshToken: response.data.refreshToken,
				expiresIn: response.data.expiresIn,
				username: response.data.nombre,
				mail: response.data.mail,
			});

			setPassword("");
			setUsername("");
			setLogin(true);

			navigate("/");
		} catch (err) {
			console.error("Error login:", err);
			setError(true);
		}
	};

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<Grid
			container
			direction="row"
			justifyContent="center"
			alignItems="center"
			size={{ xs: 12 }}
			className="load fondo-verde"
			style={{ minHeight: "80vh" }}
		>
			<Grid
				container
				direction="row"
				justifyContent="center"
				alignItems="flex-start"
				size={{ xs: 12 }}
			>
				<Grid
					container
					direction="column"
					justifyContent="center"
					alignItems="center"
					size={{ xs: 11, sm: 8, md: 6, xl: 3 }}
					gap={2}
					className="bordes-redondos fondo-blanco sombra-corta"
				>
					<Grid
						container
						direction="column"
						justifyContent="center"
						alignItems="center"
						size={{ xs: 12 }}
					>
						<PersonIcon sx={{ fontSize: 80 }} color="primary" />

						<Typography variant="h4">Iniciar sesion</Typography>

						<Typography variant="caption" sx={{ color: "gray" }}>
							Bienvenido/a a Work Solutions, por favor ingresa tus credenciales para acceder a tu cuenta.
						</Typography>
					</Grid>

					<Grid
						container
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						size={{ xs: 12 }}
					>
						<TextField
							name="email"
							id="outlined-basic"
							label="Correo electronico"
							variant="outlined"
							color="primary"
							style={{ minWidth: "100%" }}
							onChange={(e) => setUsername(e.target.value)}
							onKeyPress={handleKeyPress}
						/>
					</Grid>

					<Grid
						container
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						size={{ xs: 12 }}
						style={{ marginBottom: "0.5em" }}
					>
						<FormControl
							variant="outlined"
							style={{ minWidth: "100%" }}
							onKeyPress={handleKeyPress}
						>
							<InputLabel htmlFor="outlined-adornment-password" color="primary">
								Contrasena
							</InputLabel>
							<OutlinedInput
								name="password"
								color="primary"
								id="outlined-adornment-password"
								type={showPassword ? "text" : "password"}
								endAdornment={
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowPassword}
											onMouseDown={handleMouseDownPassword}
											edge="end"
										>
											{showPassword ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								}
								label="Contrasena"
								onChange={(e) => setPassword(e.target.value)}
							/>
						</FormControl>
					</Grid>

					<Grid
						container
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						size={{ xs: 12 }}
					>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							onClick={handleLogin}
						>
							Iniciar sesion&nbsp;<LoginIcon fontSize="small" />
						</Button>
					</Grid>

					<Grid container justifyContent="center" size={{ xs: 12 }}>
						<Link component={RouterLink} to="/politica-de-privacidad" underline="hover" color="primary">
							Consultar politica de privacidad
						</Link>
					</Grid>
				</Grid>
			</Grid>

			<Snackbar
				open={error}
				autoHideDuration={6000}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
			>
				<Alert
					onClose={handleClose}
					severity="error"
					variant="filled"
					sx={{ width: "100%" }}
				>
					Error al inicar sesion.
				</Alert>
			</Snackbar>

			<Snackbar
				open={login}
				autoHideDuration={6000}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
			>
				<Alert
					onClose={handleClose}
					severity="success"
					variant="filled"
					sx={{ width: "100%" }}
				>
					Sesion iniciada correctamente.
				</Alert>
			</Snackbar>
		</Grid>
	);
};
